import * as React from "react";
import { cn } from "@/lib/utils";

export const WidgetTitle = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn("text-sm font-medium text-primary dark:text-white", className)}
    {...props}
  />
));
WidgetTitle.displayName = "WidgetTitle";
